// extracted by mini-css-extract-plugin
module.exports = {"root":"DlpPageStats_root__lHPRD","iconAndReviews":"DlpPageStats_iconAndReviews__ZjsMT","icon":"DlpPageStats_icon__2DVx9"};